var exit_intent = (function( $ ) {

	var _init = function() {
		var $body = $( 'body' );

		if ( $body.hasClass( 'page-booking-payment' ) || $body.hasClass( 'page-booking-registration' ) ) {
			setup_popup();
		}
	};

	var _target_anchors = function() {
		return $( 'a' ).not( '[target="_blank"], [href^="#"]' );
	};

	var setup_popup = function() {
		_target_anchors().on( 'click', _show_popup );
	};

	var _show_popup = function( e ) {
		e.preventDefault();

		_target_anchors().off( 'click', _show_popup );

		var $popup = _get_popup( $( this ).attr( 'href' ) );
		// var $overlay = $( '<div id="site-overlay" style="display: none;"></div>' );
		var $wrapper = $( '#site-wrapper' );

		// $wrapper.append( $overlay );
		$wrapper.append( $popup );

		$( '#header' ).css( { 'z-index': 1 } );
		$popup.fadeIn();
		$popup.find( '.crate-popup' ).fadeIn();

		$popup.find( 'a.close-popup' ).on( 'click', _close_popup );
		$popup.find( 'a.continue-booking' ).on( 'click', _close_popup );
	};

	var _close_popup = function() {
		var $popup = $( this ).closest( '.crate-popup-wrap' );
		$( '#header' ).css( { 'z-index': 'auto' } );

		$popup.fadeOut();
		setTimeout( function() {
			$popup.remove();
		}, 400 );

		setup_popup();
	};

	var _get_popup = function( continue_link ) {
		var popup = '<div class="crate-popup-wrap">' +
				'<div class="crate-popup">' +
					'<a title="Close" class="close-popup" href="#"></a>' +
					'<div class="popup-content">' +
						'<div class="popup-title">Are you sure?</div>' +
						'<p>You are about to leave the booking process for your event. If you leave now, you\'ll lose any progress made.</p>' +
						'<div class="row">' +
							'<div class="col-sm-6">' +
								'<a href="' + continue_link + '" class="cancel-booking button hollow full-width">Cancel Booking</a>' +
							'</div>' +
							'<div class="col-sm-6">' +
								'<a href="#" class="continue-booking button full-width">Continue Booking</a>' +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>';

		return $( popup );
	};

	$( document ).ready( _init );

	return {
		setup_popup: setup_popup
	};

})( jQuery );

module.exports = exit_intent;